import { render, staticRenderFns } from "./NewPicture.vue?vue&type=template&id=6895298c&scoped=true"
var script = {}
import style0 from "./NewPicture.vue?vue&type=style&index=0&id=6895298c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895298c",
  null
  
)

export default component.exports